import { useState } from "react";
import { faqs } from "@/mocks/testimonials";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Left */}
          <div className="lg:sticky lg:top-28">
            <p className="text-[#9a9a9a] text-xs font-medium tracking-widest uppercase mb-4">Common Questions</p>
            <h2 className="text-3xl md:text-4xl font-light text-[#2d2d2d] leading-snug mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Everything you need<br />
              <span className="italic font-semibold">to know before starting.</span>
            </h2>
            <p className="text-[#6b6b6b] text-sm leading-relaxed mb-8">
              It's completely normal to have questions before reaching out. Here are some of the most common ones we hear.
            </p>
            <div className="w-16 h-0.5 bg-[#4db8b1]"></div>
          </div>

          {/* Right: Accordion */}
          <div className="flex flex-col gap-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className={`border rounded-xl overflow-hidden transition-all duration-200 ${
                  openIndex === i ? "border-[#4db8b1]/40 bg-[#f0f9f9]" : "border-[#d8f0ee] bg-white"
                }`}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <span className={`text-sm font-medium ${openIndex === i ? "text-[#418b86]" : "text-[#2d2d2d]"}`}>
                    {faq.question}
                  </span>
                  <span className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${
                    openIndex === i ? "bg-[#4db8b1] text-white rotate-45" : "bg-[#e6f6f5] text-[#6b6b6b]"
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </button>
                {openIndex === i && (
                  <div className="px-6 pb-5">
                    <p className="text-[#6b6b6b] text-sm leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
